import {useDispatch} from "react-redux";
import {useEffect} from "react";
import {getFavorites} from "../../store/reducers/favorites.reducer";
import {useFavorites} from "./useFavorites";
import { useKeycloak } from "@react-keycloak/web";

export const useGetFavorites = () => {
	const { keycloak } = useKeycloak();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getFavorites(keycloak.token));
	}, [dispatch]);

	const favorites = useFavorites();

	return favorites;
}